module.exports = __webpack_public_path__ + "static/media/DSCF6485_2.85e57aeb.JPG";